import React, { useState } from 'react';
import Nav from "react-bootstrap/Nav";
import { Link } from 'react-router-dom';
import Navbar from "react-bootstrap/Navbar";
import Logo from '../common/Logo';

const HeaderLoggedOutMobile = () => {
    const [expanded, setExpanded] = useState(false);

    return (
        <>
        <div className="d-block d-lg-none">
            <Navbar
                fixed="top"
                expanded={expanded}
                onToggle={() => setExpanded(!expanded)}
                expand="md"
                className="navbar-custom"
                style={{
                    background: 'rgba(255, 255, 255, 0.98)',
                    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                    backdropFilter: 'blur(10px)'
                }}
            >
                <Navbar.Brand className="p-0" style={{marginLeft:"10px", marginRight:"10px"}}>
                    <a href="/" style={{color: "#1a1a2e", textDecoration:"none", display: 'flex', alignItems: 'center'}}>
                        <Logo size={24} color="#6366f1" showText textColor="#1a1a2e" />
                    </a>
                </Navbar.Brand>

                <Navbar.Toggle
                    aria-controls="mobile-nav"
                    onClick={() => setExpanded(!expanded)}
                    style={{
                        border: 'none',
                        padding: '0.5rem',
                        marginRight: '10px'
                    }}
                />

                <Navbar.Collapse id="mobile-nav">
                    <Nav className="ms-auto" style={{ padding: '0.5rem 0' }}>
                        <Link
                            to="/login"
                            onClick={() => setExpanded(false)}
                            className="d-flex align-items-center"
                            style={{
                                color: "#4a5568",
                                textDecoration: "none",
                                fontSize: "1rem",
                                fontWeight: "500",
                                padding: "0.75rem 1rem",
                            }}
                        >
                            Login
                        </Link>
                        <Link
                            to="/free"
                            onClick={() => setExpanded(false)}
                            className="btn mx-3 my-2"
                            style={{
                                background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                                color: 'white',
                                fontWeight: '600',
                                fontSize: '1rem',
                                padding: '0.75rem 1.5rem',
                                borderRadius: '0.375rem',
                                textAlign: 'center'
                            }}
                        >
                            Try It Free
                        </Link>
                        <Link
                            to="/contact"
                            onClick={() => setExpanded(false)}
                            className="btn mx-3 my-2"
                            style={{
                                background: '#1a1a2e',
                                color: 'white',
                                fontWeight: '600',
                                fontSize: '1rem',
                                padding: '0.75rem 1.5rem',
                                borderRadius: '0.375rem',
                                textAlign: 'center'
                            }}
                        >
                            Contact Sales
                        </Link>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        </div>
        </>
    )
}

export default HeaderLoggedOutMobile;
